module.exports = {
    onMouseEnter: function () {
        $('body').on('mouseenter', '.product .tile-can-hover', function () {
            if (!$(this).parent().parent().hasClass('suggestion-section-body'))
                $(this).children().find('.tile-add-to-cart').removeClass('d-md-none');
        });
    },
    onMouseLeave: function () {
        $('body').on('mouseleave', '.product .tile-can-hover', function () {
            $(this).children().find('.tile-add-to-cart').addClass('d-md-none');
        });
    },

    onProductTileClick: function () {
        $('body').on('click', '.product', function () {
            let { gtmPosition, gtmTitle, gtmIsCarousel, productId } = $(this).hasClass('js-product-tile-image') ? $(this).data() : $(this).find('.js-product-tile-image').data();
            if (!gtmTitle) {
                gtmTitle = Array.from(document.querySelectorAll('.breadcrumbs-folder')).map(el => el.textContent).join(' | ');
            }
            sessionStorage.setItem(`gtmPosition_${productId}`, gtmPosition);
            sessionStorage.setItem(`gtmTitle_${productId}`, gtmTitle);
            sessionStorage.setItem(`gtmIsCarousel_${productId}`, gtmIsCarousel);
        });
    }
};
